class SteptwoController {
  constructor($state, $http, $cookies) {
    this.$http = $http;
    this.$state = $state;
    this.$cookies = $cookies;
    this.request = $state.params.request || this.getRequestCookie();
    this.data = {};

    if (!this.request) {
      this.$state.go('app.home');
    } else {
      this.getWasteTypes();
    }
  }

  getRequestCookie() {
    var request = this.$cookies.get('request');
    if (!request) return null;
    if (request == undefined) return null;

    return JSON.parse(request);
  }

  getWasteTypes() {
    let selfController = this;
    return this.$http
      .post('/Ajax.aspx/StepTwo', {
        LocalityID: this.request.Locality.ID,
        postcode: this.request.Locality.Name
      })
      .then(function(response) {
        selfController.request.PostCode = response.data.data.postCode;
        selfController.data.wasteTypes = response.data.data.wasteTypes.records;
      });
  }

  setWasteType = function(item) {
    this.request.WasteType = item;
  };

  steptwo() {
    if (this.request.WasteType) {
      this.$cookies.put('request', JSON.stringify(this.request));
      this.$state.go('app.farelist', {
        request: this.request
      });
    }
  }
}

SteptwoController.$inject = ['$state', '$http', '$cookies'];

export { SteptwoController };



/** WEBPACK FOOTER **
 ** ./src/app/components/booking/steptwo/steptwo.controller.js
 **/